module.exports = __webpack_public_path__ + "media/images/img_service_2-80adec4397d35edc253a75d8aef7ed93.png";